export enum ProsecutionActivity {
	Statement = 21,
	SupervisorApproval = 22,
	DirectorApproval = 23,
	MinisterApproval = 24,
	Saved = 25,
	MemoExchange = 26,
	ReferredToDisciplinaryCommittee = 27,
	ReferredToPublicProsecution = 28,
}
